import { createJSONStorage, type StateStorage } from 'zustand/middleware';

const store = (): Storage | null => {
  try {
    return globalThis.localStorage;
  } catch {
    return null;
  }
};

export const guardedStorage: StateStorage = {
  getItem: (name) => {
    try {
      return store()?.getItem(name) ?? null;
    } catch {
      return null;
    }
  },
  setItem: (name, value) => {
    try {
      store()?.setItem(name, value);
    } catch {
      return;
    }
  },
  removeItem: (name) => {
    try {
      store()?.removeItem(name);
    } catch {
      return;
    }
  },
};

export const persistedStorage = () => createJSONStorage(() => guardedStorage);

export const oneOf = <T extends string>(allowed: readonly T[], value: unknown, fallback: T): T =>
  allowed.find((candidate) => candidate === value) ?? fallback;
